import { IPhone } from '../../types/offer';
import { isValidPhoneObject } from './isValidPhoneObject';

interface IPhoneToString {
  phone?: IPhone | null;
}

export function phoneToString({ phone }: IPhoneToString) {
  if (phone && isValidPhoneObject({ phone })) {
    const { countryCode, code, number } = phone;

    return `${countryCode}${code}${number}`;
  }

  return '';
}
